import { AlpineComponent } from 'alpinejs';

type TabNavigationData = {
  handleBtnClick: (event: Event) => void,
}

export default ():AlpineComponent<TabNavigationData> => ({
  handleBtnClick(event: Event) {
    const buttons = this.$root.querySelectorAll('.ce-tab-navigation-buttons-btn') as NodeListOf<HTMLElement>;
    if (buttons) {
      buttons.forEach((btn: HTMLElement) => {
        btn.classList.remove('active');
      });
    }

    const target = event.target as HTMLElement;
    const btnId = target.getAttribute('data-uid');
    target.classList.add('active');
    if (btnId) {
      const contentItems = this.$root.querySelectorAll('.ce-tab-navigation-content-item') as NodeListOf<HTMLElement>;
      contentItems.forEach((content: HTMLElement) => {
        content.classList.remove('active');
        const contentId = content.getAttribute('data-uid');
        if (contentId === btnId) {
          content.classList.add('active');
        }
      });
    }
  }
});
